// extracted by mini-css-extract-plugin
export default {"nav_panel":"NavigationPanel_nav_panel__C+5-e","nav_panel_body":"NavigationPanel_nav_panel_body__C0rwq","nav_panel_item":"NavigationPanel_nav_panel_item__KuUJm"};